import { render, staticRenderFns } from "./CompetitionNotice.vue?vue&type=template&id=69b261f4&scoped=true&"
import script from "./CompetitionNotice.vue?vue&type=script&lang=js&"
export * from "./CompetitionNotice.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionNotice.vue?vue&type=style&index=0&id=69b261f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b261f4",
  null
  
)

export default component.exports